export default __webpack_public_path__ + "static/media/news52.2d572185.jpg";